/* gsw-suche:v1 T-48 Sichtbare Suche: Suchfeld im Kopf öffnet das Horizon-Suchfenster, Messhaken im dataLayer.
 * Keine zweite Suchlogik: Text und Fokus gehen an #cmdk-input, die Vorschläge holt predictive-search.js.
 * dataLayer-Vertrag (Spezifikation T-48, Namen und Felder nicht ändern):
 *   gsw_search_open          search_source: header_field_desktop | header_button_tablet | header_field_mobile | icon
 *   gsw_search_suggest_click search_term, result_type (product, collection, article, page, query, popular, category), result_position
 *   gsw_search_no_results    search_term, search_surface (modal | page)
 * Weg: Shopify.analytics.publish (Custom Pixel, dort läuft GTM). Zusätzlich window.dataLayer.push nur zur Sichtprüfung in der Vorschau.
 * Das GA4-Ereignis search sendet das Theme nicht selbst: Shopifys search_submitted von der Ergebnisseite deckt es ab.
 */
(function () {
  if (window.__gswSuche) return;
  window.__gswSuche = true;
  window.dataLayer = window.dataLayer || [];

  var nextSource = null;
  var pendingField = null;
  var lastNoResults = null;
  var isOpen = false;

  function push(obj) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(obj);
    if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
      var name = obj.event;
      var payload = {};
      Object.keys(obj).forEach(function (k) {
        if (k !== 'event') payload[k] = obj[k];
      });
      try {
        Shopify.analytics.publish(name, payload);
      } catch (e) {}
    }
  }

  function modal() {
    return document.getElementById('search-modal');
  }

  function modalInput() {
    return document.getElementById('cmdk-input');
  }

  function canOpen() {
    var m = modal();
    return !!(m && typeof m.showDialog === 'function');
  }

  function fieldSource() {
    // Vertragswerte: ab 990 px Desktopfeld, 750 bis 989 px (Tablet) header_button_tablet, darunter mobil
    if (window.matchMedia('(min-width: 990px)').matches) return 'header_field_desktop';
    if (window.matchMedia('(min-width: 750px)').matches) return 'header_button_tablet';
    return 'header_field_mobile';
  }

  function openModalFrom(field) {
    if (isOpen) return;
    pendingField = field;
    nextSource = fieldSource();
    modal().showDialog();
  }

  /* ---- Suchfeld im Kopf ---- */
  function initBar() {
    // Kürzerer Platzhalter im schmalen Feld (unter 750 px), damit er nicht abgeschnitten wird
    var mq = window.matchMedia('(max-width: 749px)');
    function setPlaceholders() {
      document.querySelectorAll('.gsw-suche-form__input[data-placeholder-lang]').forEach(function (el) {
        el.placeholder = mq.matches
          ? el.getAttribute('data-placeholder-mobil') || el.getAttribute('data-placeholder-lang')
          : el.getAttribute('data-placeholder-lang');
      });
    }
    setPlaceholders();
    if (mq.addEventListener) mq.addEventListener('change', setPlaceholders);
    var forms = document.querySelectorAll('[data-gsw-suche-form]');
    forms.forEach(function (form) {
      var field = form.querySelector('input[name="q"]');
      if (!field) return;

      // Antippen oder Anklicken öffnet das Fenster (kein Öffnen beim reinen Fokus, WCAG 3.2.1)
      field.addEventListener('click', function () {
        if (canOpen()) openModalFrom(field);
      });

      // Tippen öffnet das Fenster und nimmt den Text mit
      field.addEventListener('input', function () {
        if (canOpen()) openModalFrom(field);
      });

      // Enter im leeren Feld öffnet das Fenster statt eine leere Suche zu senden
      field.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' && !field.value.trim() && canOpen()) {
          event.preventDefault();
          openModalFrom(field);
        }
      });

      form.addEventListener('submit', function (event) {
        if (!field.value.trim() && canOpen()) {
          event.preventDefault();
          openModalFrom(field);
        }
      });
    });
  }

  /* ---- Öffnen: Quelle, Text und Fokus übergeben ---- */
  function onOpen() {
    if (isOpen) return;
    isOpen = true;
    var source = nextSource || 'icon';
    nextSource = null;
    push({ event: 'gsw_search_open', search_source: source });

    var input = modalInput();
    if (!input) return;
    var value = '';
    if (pendingField) {
      value = pendingField.value;
      pendingField.value = '';
      pendingField = null;
    }
    input.focus();
    if (value) {
      input.value = value;
      input.setSelectionRange(value.length, value.length);
      input.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: value }));
    }
  }

  function initModal() {
    var m = modal();
    if (!m) return;
    m.addEventListener('dialog:open', onOpen);
    m.addEventListener('dialog:close', function () {
      isOpen = false;
      pendingField = null;
    });

    // Lupen-Knopf im Kopf (nur sichtbar, wenn das Suchfeld ausgeschaltet ist): Quelle icon
    document.addEventListener(
      'click',
      function (event) {
        var btn = event.target.closest && event.target.closest('search-button button');
        if (btn) nextSource = 'icon';
      },
      true
    );

    // Klick auf einen Vorschlag im Fenster
    m.addEventListener(
      'click',
      function (event) {
        var el = event.target.closest && event.target.closest('[data-gsw-type]');
        if (!el) return;
        var all = Array.prototype.slice.call(m.querySelectorAll('[data-gsw-type]'));
        var input = modalInput();
        var inner = m.querySelector('[data-gsw-term]');
        var term = el.getAttribute('data-gsw-term');
        if (term === null) term = (inner && inner.getAttribute('data-gsw-term')) || (input && input.value) || '';
        push({
          event: 'gsw_search_suggest_click',
          search_term: term,
          result_type: el.getAttribute('data-gsw-type'),
          result_position: all.indexOf(el) + 1
        });
      },
      true
    );

    // Ergebnisbereich beobachten: Ansage der Trefferzahl, Knopf-Text, Ereignis "keine Treffer"
    var results = m.querySelector('.predictive-search-form__content');
    if (results) {
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          onResults(m, results);
        });
      }).observe(results, { childList: true, subtree: true });
    }
  }

  function onResults(m, results) {
    var live = m.querySelector('[data-gsw-live]');
    var viewAll = m.querySelector('[ref="viewAllButton"]');
    var inner = results.querySelector('[data-gsw-term]');
    var nr = results.querySelector('[data-gsw-no-results]');
    var term = inner ? inner.getAttribute('data-gsw-term') : '';

    if (nr) {
      var t = nr.getAttribute('data-gsw-no-results');
      if (live) live.textContent = 'Keine Treffer für „' + t + '“.';
      if (lastNoResults !== t) {
        lastNoResults = t;
        push({ event: 'gsw_search_no_results', search_term: t, search_surface: 'modal' });
      }
    } else {
      lastNoResults = null;
      if (live) {
        var n = inner ? parseInt(inner.getAttribute('data-gsw-count'), 10) : NaN;
        live.textContent = !isNaN(n) && n > 0 ? n + ' Treffer für „' + term + '“.' : '';
      }
    }
    if (viewAll) {
      viewAll.textContent = term ? 'Alle Ergebnisse für „' + term + '“ anzeigen' : 'Alle Ergebnisse anzeigen';
    }
  }

  /* ---- 0 Treffer auf der Ergebnisseite ---- */
  function pageNoResults() {
    var el = document.querySelector('[data-gsw-no-results][data-gsw-surface="page"]');
    if (el) {
      push({
        event: 'gsw_search_no_results',
        search_term: el.getAttribute('data-gsw-no-results'),
        search_surface: 'page'
      });
    }
  }

  function init() {
    initBar();
    initModal();
    pageNoResults();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
